import { BRAND_DEFINITION } from '../../constants'

const getBrandDefinitionBreadcrumbItemByTaskId = brandDefinitionTaskId => ({
  path: `/tasks/brand-definition/${brandDefinitionTaskId}`,
  type: BRAND_DEFINITION,
  name: 'Brand Definition',
})

export default getBrandDefinitionBreadcrumbItemByTaskId
